import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const theme = {
  primary: "#0080c4",
  secondary: "#6cccff",
  background: "#FFFFFF",
  light: "#FFFFFF",
  dark: "#000000",
  bg: "#F8FBFB",
};

const injectThemeVariables = () => {
  const root = document.documentElement;
  Object.keys(theme).forEach(key => {
    root.style.setProperty(`--theme-${key}`, theme[key]);
  });
};

Vue.nextTick(() => {
  injectThemeVariables();
});

export default new Vuetify({
  theme: {
    themes: {
      light: theme,
    },
  },
});

export { theme, injectThemeVariables };
